import React from 'react';

export default function WingitField({
  label,
  error,
  helper,
  children,
}) {
  return (
    <label
      style={{
        display: 'grid',
        gap: '0.35rem',
      }}
    >
      {label && (
        <span
          style={{
            color: '#d7ebff',
            fontSize: '0.82rem',
            fontWeight: 700,
          }}
        >
          {label}
        </span>
      )}

      {children}

      {helper && (
        <div
          style={{
            color: '#8db7e6',
            fontSize: '0.82rem',
            lineHeight: 1.4,
          }}
        >
          {helper}
        </div>
      )}

      {error && (
        <div
          style={{
            color: '#ffb3b3',
            fontSize: '0.82rem',
          }}
        >
          {error}
        </div>
      )}
    </label>
  );
}